<template>
  <div>
    <div class="left-home">
      <div class="chart">
        <el-row class="chart-title">
          <el-col :span="24">
            <el-button type="text" @click="findByNow" :class="btn1Class" :loading="nowLoading">今天</el-button>
            <el-button type="text" @click="findByYesterDay" :class="btn2Class" :loading="yesterDayLoading">昨天</el-button>
          </el-col>
        </el-row>
        
        <el-row class="row-chart">
          <el-col :span="6" class="col-outqty">
            <div @click="ckDetailClick">
              <el-card shadow="never">
                <div style="font-size:14px; margin-top:8px; color:#868686">出库数量</div>
                <div style="margin-top:10px; font-size:26px; font-weight:bold">{{outQty}}</div>
              </el-card>
            </div>
          </el-col>
          
          <el-col :span="6" class="col-outmoney">
            <div @click="ckDetailClick">
              <el-card shadow="never">
                <div style="font-size:14px; margin-top:8px; color:#868686">出库金额</div>
                <div style="margin-top:10px;"><span style="font-size:16px;">￥</span> <span style="font-size:26px;font-weight:bold">{{outMoney}}</span></div>
              </el-card>
            </div>
          </el-col>
          
          <el-col :span="6" class="col-inqty">
            <div @click="rkDetailClick">
              <el-card shadow="never">
                <div style="font-size:14px; margin-top:8px; color:#868686">入库数量</div>
                <div style="margin-top:10px; font-size:26px; font-weight:bold">{{inQty}}</div>
              </el-card>
            </div>
          </el-col>
          
          <el-col :span="6" class="col-inmoney">
            <div @click="rkDetailClick">
              <el-card shadow="never">
                <div style="font-size:14px; margin-top:8px; color:#868686">入库金额</div>
                <div style="margin-top:10px; "><span style="font-size:16px;">￥</span> <span style="font-size:26px;font-weight:bold">{{inMoney}}</span></div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
      
      <!-- 导航 -->
      <div class="nav">
        <el-row class="row-one">
          <el-col :span="6" class="col-1">
            <el-card shadow="never" @click.native="handleOutBill">
              <div class="circle" style="background-color:#00C598"><i class="el-icon-document-copy" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">出库单</div>
            </el-card>
          </el-col>
          <el-col :span="6" class="col-2">
            <el-card shadow="never" @click.native="handleInBill">
              <div class="circle" style="background-color:#0097DD"><i class="el-icon-shopping-cart-2" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">入库单</div>
            </el-card>
          </el-col>
          <el-col :span="6" class="col-3">
            <el-card shadow="never" @click.native="handleViewStock">
              <div class="circle" style="background-color:#FFA13C"><i class="el-icon-search" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">查库存</div>
            </el-card>
          </el-col>
          <el-col :span="6" class="col-4">
            <el-card shadow="never" @click.native="handleStockDetail">
              <div class="circle" style="background-color:#9C72CC"><i class="el-icon-document" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">库存明细</div>
            </el-card>
          </el-col>
        </el-row>
        
        <el-row class="row-tow">
          <el-col :span="6" class="col-5">
            <el-card shadow="never" @click.native="handleGoods">
              <div class="circle" style="background-color:#00B5EA"><i class="el-icon-sell" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">商品</div>
            </el-card>
          </el-col>
          <el-col :span="6" class="col-6">
            <el-card shadow="never" @click.native="handleCustom">
              <div class="circle" style="background-color:#FF9170"><i class="el-icon-s-custom" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">收货方</div>
            </el-card>
          </el-col>
          <el-col :span="6" class="col-7">
            <el-card shadow="never" @click.native="handleSupplier">
              <div class="circle" style="background-color:#00E2A7"><i class="el-icon-user" style="color:#fff; font-size:28px" /></div>
              <div style="font-size:20px; margin-top:8px">供货方</div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="never" @click.native="handleStore">
              <div class="circle" style="background-color:#0097DD"><i class="el-icon-s-home" style="color:#fff; font-size:px" /></div>
              <div style="font-size:20px; margin-top:8px">仓库设置</div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <div class="right-home">
      <el-card>
        <div style="margin-bottom:5px;  font-size:16px"><i class="el-icon-s-comment
          " style="color:#2f54eb; margin-right:7px" />新手引导</div>
        <div style="margin-bottom:14px; font-size:14px; color:#969696">了解可易云如何使用</div>
        <div style=" font-size:14px; color:#2f54eb; cursor: pointer;"><span @click="help">使用引导</span> &nbsp;|&nbsp; <span @click="doRegister">注册帐号</span></div>
      </el-card>
      
      <el-card style="margin-top:10px">
        <div slot="header"><i class="el-icon-s-data" style="color:#2f54eb; margin-right:7px" /><span>明细报表</span></div>
        <div class="text-item" @click="ckDetailClick">出库单对账明细表</div>
        <div class="text-item" @click="rkDetailClick">入库单对账明细表</div>
        <div class="text-item" @click="pdDetailClick">盘点单对账明细表</div>
        <div class="text-item" @click="dbDetailClick">调货单对账明细表</div>
      </el-card>
      
      <el-card style="margin-top:10px">
        <div slot="header"><i class="el-icon-s-marketing" style="color:#2f54eb; margin-right:7px" /><span>汇总报表</span></div>
        <div class="text-item" @click="rkGoodsCountClick">按商品统计入库</div>
        <div class="text-item" @click="rkUnitCountClick">按供货商统计入库</div>
        <div class="text-item" @click="rkEmpCountClick">按经手人统计入库</div>
        <div class="text-item" @click="ckGoodsCountClick">按商品统计出库</div>
        <div class="text-item" @click="ckUnitCountClick">按提货方统计出库</div>
        <div class="text-item" @click="ckEmpCountClick">按经手人统计出库</div>
        <div class="text-item" @click="lrCountClick">商品利润分析</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import common from '../utils/common';
export default {
  data() {
    return {
      nowLoading: false,
      yesterDayLoading: false,
      btn1Class: "activeBtn",
      btn2Class: "normalBtn",
      outQty: 0,
      outMoney: 0,
      inQty: 0,
      inMoney: 0,
      date1: common.getNowDate(),
      date2: common.getNowDate(),
      a: [],
    }
  },
  
  created() {
    //保存keepLive这个对像的缓存,在store/tab.js下保存
    this.$store.commit('initKeepLive', this.$vnode.parent);
  },
  
  mounted() {
    this.findAll();
  },
  
  methods: {
    findByNow() {
      this.nowLoading = true;
      this.btn1Class = 'activeBtn';
      this.btn2Class = 'normalBtn';
      this.date1 = common.getNowDate();
      this.date2 = common.getNowDate();
      this.findAll();
      this.nowLoading = false;
    },
    
    findByYesterDay() {
      this.yesterDayLoading = true;
      this.btn1Class = 'normalBtn';
      this.btn2Class = 'activeBtn';
      
      let day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      const s1 = day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
      
      this.date1 = s1;
      this.date2 = s1;
      this.findAll();
      this.yesterDayLoading = false;
    },
    
    //返回所有信息
    async findAll() {
      try {
        const res = await this.$axios.get(common.serverApi(`chart?beginDate=${this.date1}&endDate=${this.date2}`));
        if (res.data.code === 1000) {
          if (common.checkUserPower('出库单管理', 'canview') || common.checkUserPower('出库单明细表', 'canview')){
            this.outQty = common.fomatFloat(res.data.result.outData[0].outqty, 'QTY');
            this.outMoney = common.fomatFloat(res.data.result.outData[0].outmoney, 'MONEY');
          }
          else{
            this.outQty = '-';
            this.outMoney = '-';
          }

          if (common.checkUserPower('入库单管理', 'canview') || common.checkUserPower('入库单明细', 'canview')){
            this.inQty = common.fomatFloat(res.data.result.inData[0].inqty, 'QTY');
            this.inMoney = common.fomatFloat(res.data.result.inData[0].inmoney, 'MONEY');
          } 
          else{
            this.inQty = '-';
            this.inMoney = '-';
          }
        }
        else {
          common.msgError(res.data.message);
        }
      }
      catch (err) {
        console.log(err);
        common.msgError("获取异常");
      }
    },
    
    //注册
    doRegister() {
      this.$store.commit('clearTag');
      sessionStorage.clear();
      this.$router.push({ path: "/register" });
      this.$router.go(0);
    },
    
    //帮助
    help() {
      const routeInfo = {
        id: "411",
        name: "help",
        path: "/help",
        title: "使用引导",
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //出库单
    handleOutBill() {
      if (!common.checkUserPower('出库单管理', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "201",
        name: "outbill",
        path: "/outbill",
        title: "出库单管理",
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //入库单
    handleInBill() {
      if (!common.checkUserPower('入库单管理', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "202",
        name: "inbill",
        path: "/inbill",
        title: "入库单管理",
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //查看库存
    handleViewStock() {
      if (!common.checkUserPower('查看库存', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "205",
        name: "viewstock",
        path: "/viewstock",
        title: "商品库存",
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //库存明细
    handleStockDetail() {
      if (!common.checkUserPower('出入明细表', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "206",
        name: "stockdetail",
        path: "/stockdetail",
        title: "出入库明细表",
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //商品
    handleGoods() {
      if (!common.checkUserPower('商品资料管理', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "101",
        path: "/goods",
        name: "goods",
        title: "商品资料"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //收货方
    handleCustom() {
      if (!common.checkUserPower('收货方资料管理', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "104",
        path: "/custom",
        name: "custom",
        title: "收货方资料"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //供货方
    handleSupplier() {
      if (!common.checkUserPower('供货方资料管理', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "105",
        path: "/supplier",
        name: "supplier",
        title: "供货方资料"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //仓库
    handleStore() {
      if (!common.checkUserPower('仓库设置', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "106",
        path: "/store",
        name: "store",
        title: "仓库设置"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //出库对账明车
    ckDetailClick() {
      if (!common.checkUserPower('出库单明细表', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "301",
        name: "outdetail",
        path: "/outdetail",
        title: "出库对账明细"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //入库对账明细
    rkDetailClick() {
      if (!common.checkUserPower('入库单明细表', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "302",
        name: "indetail",
        path: "/indetail",
        title: "入库对账明细"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //盘点对账
    pdDetailClick() {
      if (!common.checkUserPower('盘点单明细表', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "303",
        name: "pddetail",
        path: "/pddetail",
        title: "盘点单明细表"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //调货明细表
    dbDetailClick() {
      if (!common.checkUserPower('调货单明细表', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "304",
        name: "dbdetail",
        path: "/dbdetail",
        title: "调货单明细表"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按商品入库统计
    rkGoodsCountClick() {
      if (!common.checkUserPower('按商品统计入库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "305",
        name: "incountgoods",
        path: "/incountgoods",
        title: "按商品统计入库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按单位统计入库
    rkUnitCountClick() {
      if (!common.checkUserPower('按往来单位统计入库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "306",
        name: "incountunit",
        path: "/incountunit",
        title: "按往来单位统计入库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按经手人统计入库
    rkEmpCountClick() {
      if (!common.checkUserPower('按经手人统计入库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "307",
        name: "incountemp",
        path: "/incountemp",
        title: "按经手人统计入库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按商品统计出库
    ckGoodsCountClick() {
      if (!common.checkUserPower('按商品统计出库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "308",
        name: "outcountgoods",
        path: "/outcountgoods",
        title: "按商品统计出库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按单位统计出库
    ckUnitCountClick() {
      if (!common.checkUserPower('按往来单位统计出库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "309",
        name: "outcountunit",
        path: "/outcountunit",
        title: "按往来单位统计出库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //按经手人统计出库
    ckEmpCountClick() {
      if (!common.checkUserPower('按经手人统计出库', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "310",
        name: "outcountemp",
        path: "/outcountemp",
        title: "按经手人统计出库"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    },
    
    //利润
    lrCountClick() {
      if (!common.checkUserPower('商品利润', 'canview')) {
        common.msgPopInfo('您所在的角色组无权限使用该功能！');
        return false;
      }
      
      const routeInfo = {
        id: "311",
        name: "lr",
        path: "/lr",
        title: "商品利润"
      }
      this.$store.commit('addTag', routeInfo);
      this.$router.push({ path: routeInfo.path });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/desktop.vue